// src/components/NuovaPassword.js — nuova password + conferma, con le regole visibili (W447)
// Usato dalla pagina del link via email (AzioneAccount) e da Impostazioni → Profilo.
import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { PASSWORD_MIN, robustezzaPassword, ETICHETTE_ROBUSTEZZA } from "../utils/regolePassword";

const COLORI = ["#dc2626", "#f59e0b", "#16a34a", "#15803d"];

export default function NuovaPassword({ valore, conferma, onValore, onConferma, email = "", autoFocus = false }) {
  const [vedi, setVedi] = useState(false);
  const forza = robustezzaPassword(valore);
  const regole = [
    { ok: valore.length >= PASSWORD_MIN, testo: `Almeno ${PASSWORD_MIN} caratteri` },
    { ok: !!valore && !(email && [email.toLowerCase(), email.toLowerCase().split("@")[0]].includes(valore.toLowerCase())), testo: "Diversa dalla tua email" },
    { ok: !!conferma && valore === conferma, testo: "Le due password coincidono" },
  ];
  return (
    <div>
      <div className="form-group">
        <label className="form-label" htmlFor="nuova-password">Nuova password</label>
        <div style={{ position: "relative" }}>
          <input id="nuova-password" className="input" type={vedi ? "text" : "password"} autoComplete="new-password" autoFocus={autoFocus}
            value={valore} onChange={e => onValore(e.target.value)} placeholder={`Almeno ${PASSWORD_MIN} caratteri`} style={{ paddingRight: 40 }} />
          <button type="button" aria-label={vedi ? "Nascondi password" : "Mostra password"} onClick={() => setVedi(!vedi)}
            style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#9ca3af" }}>
            {vedi ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
        {valore && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}>
            <div style={{ flex: 1, height: 5, borderRadius: 3, background: "#e5e7eb", overflow: "hidden" }}>
              <div style={{ width: `${(forza + 1) * 25}%`, height: "100%", background: COLORI[forza], transition: "width .2s" }} />
            </div>
            <span style={{ fontSize: 11.5, fontWeight: 600, color: COLORI[forza] }}>{ETICHETTE_ROBUSTEZZA[forza]}</span>
          </div>
        )}
      </div>
      <div className="form-group">
        <label className="form-label" htmlFor="conferma-password">Conferma la nuova password</label>
        <input id="conferma-password" className="input" type={vedi ? "text" : "password"} autoComplete="new-password"
          value={conferma} onChange={e => onConferma(e.target.value)} placeholder="Riscrivila uguale" />
      </div>
      <ul data-test="regole-password" style={{ listStyle: "none", padding: 0, margin: "0 0 14px", fontSize: 12, lineHeight: 1.7 }}>
        {regole.map(r => <li key={r.testo} style={{ color: r.ok ? "#15803d" : "#6b7280" }}>{r.ok ? "✓" : "○"} {r.testo}</li>)}
      </ul>
    </div>
  );
}
